import React, { useMemo, useState } from 'react';
import { resolveMediaUrl } from '../utils/url';

export default function AvatarImg({ src, alt = 'Avatar', size = 40, className, style }) {
  const initial = useMemo(() => resolveMediaUrl(src || '/avatars/default-avatar.png'), [src]);
  const [curSrc, setCurSrc] = useState(initial);
  const s = typeof size === 'number' ? size : Number(size) || 40;
  return (
    <img
      src={curSrc}
      alt={alt}
      onError={() => {
        const fallback = resolveMediaUrl('/avatars/default-avatar.png');
        if (curSrc !== fallback) setCurSrc(fallback);
      }}
      className={className}
      style={{ width: s, height: s, borderRadius: '50%', objectFit: 'cover', ...style }}
    />
  );
}
